import { combineReducers } from 'redux';
import user from 'pages/Registration/SelectMethod/state/reducer';
import coreid from 'pages/Registration/methods/BankID/reducer';
import document from 'pages/Registration/methods/Document/reducer';

export default combineReducers({
    user,
    coreid,
    document
});